import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { EnrolmentComponent } from './components/enrolment/enrolment.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ResetPinComponent } from './components/reset-pin/reset-pin.component';
import { UnlockAccountComponent } from './components/unlock-account/unlock-account.component';


const routes: Routes = [
  { path: 'home', component: HomeComponent },
  { path: '', component: HomeComponent },
  { path: 'change-password', component: ChangePasswordComponent },
  { path: 'unlock-account', component: UnlockAccountComponent },
  { path: 'reset-pin', component: ResetPinComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'enrollment', component: EnrolmentComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
